import { useAtomValue, useSetAtom } from 'jotai';

import { NoteTypeEnum } from '@grow-therapy-team/seedling-components';

import { ProviderDrawerState, drawerStateAtom, selectedClientInfoAtom } from '../state';
import { useGetPatientByShortId } from '../useGetPatientByShortId';
import { ProgressNoteSection } from './ProgressNoteSection';

export function ProgressNoteSectionWrapper({ className }: { className?: string }) {
  const selectedPatientShortId = useAtomValue(selectedClientInfoAtom)?.patientShortId;

  const { loading: isLoading, data: patientChartData, error } = useGetPatientByShortId(selectedPatientShortId);
  const lastAppointment = patientChartData?.patientChart?.lastAppointment;
  const startTime = lastAppointment?.timeStart ? new Date(lastAppointment.timeStart as string) : null;
  const endTime = lastAppointment?.timeEnd ? new Date(lastAppointment.timeEnd as string) : null;

  const setDrawerState = useSetAtom(drawerStateAtom);
  const openProgressNote = () => {
    setDrawerState(ProviderDrawerState.PROGRESS_NOTES);
  };

  const notes = patientChartData?.patientChart?.lastAppointment?.notes;
  const noteType: NoteTypeEnum = notes?.[0]?.noteType ?? ('' as NoteTypeEnum);

  const isProgressNote = noteType === NoteTypeEnum.GROW_PROGRESS;

  const state = isLoading ? 'loading' : error ? 'error' : 'default';

  if (notes && !isProgressNote) {
    return null;
  }

  return (
    <ProgressNoteSection
      className={className}
      state={state}
      onClick={openProgressNote}
      startTime={startTime}
      endTime={endTime}
    />
  );
}
